import Image from "next/image"

export const PromoIllustration = () => (
  <div className="flex h-16 shrink-0 items-center overflow-visible">
    <Image
      src="/img/illus/15-percent.svg"
      alt="promo"
      width={96}
      height={96}
      className="translate-x-4"
    />
  </div>
)
